import { useContext } from "react";
import { ProjectListContext } from "../providers/ProjectListProvider";

export const useProjectListContext = () => useContext(ProjectListContext);
